import { Inject, Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { AppStartupContext, STARTUP_CONTEXT_TOKEN } from "@obg/ngx.core";
import { ConfigService, PlatformService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class FabricLobbyConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientGaming>,
		private platformService: PlatformService,
		@Inject(STARTUP_CONTEXT_TOKEN) private startupContext: AppStartupContext
	) {}
	isFabricLobbyEnabled(): boolean {
		return this.configService.get((x) => x.gamingUi.gamingFabricLobby.isEnabled, false);
	}
	blockSSRForClients(): boolean {
		return (
			(this.platformService.isBrowser && this.isFabricLobbyEnabled()) ||
			!this.isFabricLobbyEnabled() ||
			this.startupContext?.isBot === true ||
			this.startupContext?.isSiteMapCrawler === true
		);
	}
}
